//
import WebComponent from '../webComponents/WebComponent';
import tippy from 'tippy.js';

export default class ShareUrl extends WebComponent {
  constructor(props) {
    super(props);
    this.clipboardText = window.location;
    this.tip = null;
    this.timer = null;
    this.fakeElem = null;
  }

	didMount() {
		const {
      shareUrl,
      shareUrlCommand,
      mode,
		} = this.props;

		// onLoad mode
		if (mode == 'onLoad') {
      this.getText();
      this.selectFake();
    }
		// onClick mode
		else {
      this.on('click', (e)=> {
        this.getText();

        if (shareUrl && shareUrlCommand) {
          this.processCommand(shareUrl, shareUrlCommand);
        }
        else {
          this.selectFake();
        }

        e.preventDefault();
      });

      this.tip = tippy(this.element, {
        arrow: true,
        theme: 'esp',
        placement: 'left',
        trigger: 'manual',
      });
    }
	}

	getText() {
    const {
      shareUrlPath,
      shareUrlParam,
      shareUrl,
      shareUrlCommand,
    } = this.props;

    if (shareUrl && shareUrlCommand) {
      this.processCommand(shareUrl, shareUrlCommand);
    }

    // pozije aktualni domenu a hodnotu z data-share-url-path
    if (shareUrlPath) {
      this.clipboardText = window.location.protocol + '//' + window.location.hostname + '/' + shareUrlPath;
    }
    // pouzije aktualni window.location doplnenou o hodnotu z data-share-url-param
    if (shareUrlParam) {
      this.clipboardText = window.location + shareUrlParam;
    }
    // pouzije hodnotu z data-share-url
    if (shareUrl) {
      this.clipboardText = shareUrl;

      //pouzije hodnotu z data-share-url a data-share-url-param
      if (shareUrlParam) {
        this.clipboardText = shareUrl + shareUrlParam;
      }
    }

    return this.clipboardText;
  }

  willUnMount() {
    clearTimeout(this.timer);
    this.clipboardText = window.location;
    this.tip = null;
    this.timer = null;
  }

  selectFake() {
    this.removeFake();

    this.fakeElem = document.createElement('textarea');
    // Prevent zooming on iOS
    this.fakeElem.style.fontSize = '12pt';
    // Reset box model
    this.fakeElem.style.border = '0';
    this.fakeElem.style.padding = '0';
    this.fakeElem.style.margin = '0';
    // Move element out of screen horizontally
    this.fakeElem.style.position = 'absolute';
    this.fakeElem.style['left'] = '-9999px';
    // Move element to the same position vertically
    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.fakeElem.style.top = yPosition + 'px';

    this.fakeElem.setAttribute('readonly', '');
    this.fakeElem.value = this.clipboardText;

    this.element.appendChild(this.fakeElem);
    this.fakeElem.select();
    this.copyText();
  }

  removeFake() {
    if (this.fakeElem) {
      this.element.removeChild(this.fakeElem);
      this.fakeElem = null;
    }
  }

  copyText() {
    let succeeded = void 0;

    try {
      succeeded = document.execCommand('copy');
    } catch (err) {
      succeeded = false;
    }

    if (succeeded) {
      this.processSuccess();
    }
  }

  processSuccess() {
    const {
      shareUrlSuccess,
    } = this.props;
    if (this.tip) {
      this.tip.setContent(shareUrlSuccess);
      this.tip.show();

      this.timer = setTimeout(() => {
        this.tip.hide();
      }, 2000);
    }
  }


  processCommand(url, eventName) {
    const xhr = new XMLHttpRequest();

    const splittedUrl = url.split('?');

    xhr.open('POST', splittedUrl[0] + '/' + eventName + '?' + splittedUrl[1], false );
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.clipboardText = window.location.protocol + '//'  + window.location.host + splittedUrl[0] + '/' + JSON.parse(xhr.responseText);
        this.selectFake();
      }
    };
    xhr.send();
  }
}




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/ShareUrl.js